import { UploadCloud } from "lucide-react";
import { Button } from "../../../../../components/ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../../../../../components/ui/alert-dialog";

interface SendToAzumiButtonProps {
  onConfirm: () => void;
  disabled?: boolean;
}

export function SendToAzumiButton({
  onConfirm,
  disabled = false,
}: SendToAzumiButtonProps) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button disabled={disabled} className="gap-2">
          <UploadCloud className="h-4 w-4" />
          Enviar para Azumi
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Enviar para Azumi</AlertDialogTitle>
          <AlertDialogDescription>
            Mandar os cadastros para Azumi?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Confirmar</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
